module.exports = __webpack_public_path__ + "img/setting.5eebd0b6.svg";